import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIList from 'UIComponents/list/UIList';
import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingsNotYoursTooltip = ({
  meetingURL
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      className: "m-bottom-6",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.linkTo"
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        readOnly: true,
        value: meetingURL
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.title"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      childClassName: 'm-bottom-3',
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.copiedTemplate"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.deleteLink"
        })
      })]
    })]
  });
};
export default MeetingsNotYoursTooltip;